import { Injectable } from '@angular/core';
import { HttpService } from '../services/http-service';
import {Observable} from 'rxjs';

@Injectable()
export class WalletService {
    constructor(private httpService: HttpService) {

    }

    currencyState(): Observable<any[]> {
        return this.httpService.get('/api/wallet/currency-state');
    }

    transactions(searchForm): Observable<any[]> {
        return this.httpService.get('/api/wallet/account-transactions', searchForm);
    }

    createTransactionRecharge(transaction: any): Observable<any> {
        return this.httpService.post('api/wallet/create-recharge', transaction);
    }

    createTransactionExchange(transaction: any, code?: string): Observable<any> {
        let item = transaction;
        transaction.SmsCode = code;
        return this.httpService.post('api/wallet/create-exchange', item);
    }

    createTransactionWithdrawal(transaction: any, code?: string): Observable<any> {
        let item = transaction;
        transaction.SmsCode = code;
        return this.httpService.post('api/wallet/create-withdrawal', item);
    }

    masterCurrencies(): Observable<any[]> {
        return this.httpService.get('api/wallet/master-currencies');
    }

    slaveCurrencies(masterCurrency: any): Observable<any[]> {
        return this.httpService.get('api/wallet/slave-currencies', { masterCurrency: masterCurrency });
    }

    title(transactionTypeId: any): Observable<any> {
        return this.httpService.get('api/user/get-title', { transactionTypeId: transactionTypeId });
    }

    currentRate(amount: any, currency: any, masterCurrency: any, slaveCurrency: any, accountBankcode: any, timeOption: boolean, costOption: boolean): Observable<any[]> {
        let rate = this.httpService.get('api/wallet/get-current-rate', {
            amount: amount,
            currencyId: currency,
            slaveCurrencyId: slaveCurrency,
            masterCurrencyId: masterCurrency,
            accountBankcodeId: accountBankcode,
            timeopt: timeOption,
            costopt: costOption
        });
        return rate;
    }

    loadCommission(masterCurrency, slaveCurrency, currencyId, cantorBankcode, accountBankcode, amount, timeOption, costOption) {
        let result = this.httpService.get('api/wallet/get-transaction-commission', {
            masterCurrency: masterCurrency,
            slaveCurrency: slaveCurrency,
            currencyId: currencyId,
            cantorBankcode: cantorBankcode,
            accountBankcode: accountBankcode,
            amount: amount,
            timeopt: timeOption,
            costopt: costOption
        });
        return result;
    }

    purposeLimit(currency: number) {
        let result = this.httpService.get('api/wallet/get-purpose-limit', {
            currency: currency
        });
        return result;
    }

    isSmsNeededForTransactionAction(bankCodeId)
    {
        let result = this.httpService.get('api/wallet/is-sms-needed-for-transaction', {
            bankCodeId: bankCodeId
        });
        return result;
    }

    isEmptyBalance()
    {
        let result = this.httpService.get('api/wallet/empty-balance');
        return result;
    }
}
